import { TDiscoveryQuizAnswer } from '@lib/tools/discoveryQuiz/types';

import { DiscoveryQuizAnswersItem } from '@components/web/src/atoms/DiscoveryQuizAnswersItem/DiscoveryQuizAnswersItem';
import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';

interface Props {
  selectedAnswer: null | number;
  handleAnswerClick: (selectedAnswerId: number) => void;
  answers: TDiscoveryQuizAnswer[];
}

export const DiscoveryQuizAnswers = ({ answers, selectedAnswer = null, handleAnswerClick }: Props) => (
  <Flexbox isFullWidth direction="column" gap={0}>
    {answers.map(({ id, isCorrectAnswer, text }) => (
      <DiscoveryQuizAnswersItem
        key={id}
        id={id}
        isCorrectAnswer={isCorrectAnswer}
        isSelectedAnswer={selectedAnswer && selectedAnswer === id}
        text={text}
        handleItemClick={(event, selectedAnswerId: number) => {
          event.stopPropagation();
          if (!selectedAnswer) {
            handleAnswerClick(selectedAnswerId);
          }
        }}
      />
    ))}
  </Flexbox>
);
